import "../../assets/css/demo.css";
import React, { Component } from "react";
import { Card, CardBody } from "reactstrap";
import { FloatButton, Typography, Watermark } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { PanelHeader } from "components";
import axios from "axios";
import UserData from "./components/UserData";
import BillingData from "./components/BillingData";
import ContactData from "./components/ContactData";
import ServicesData from "./components/ServicesData";
import ContractConditions from "./components/ContractConditions";
import BusinessData from "./components/BusinessData";
import naduLogo from "../../assets/img/nadunet-watermark.png";
import BusinessSignature from "./components/BusinessSignature";
import UserSignature from "./components/UserSignature";
import ReactToPrint from "react-to-print";

class ViewContract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      user_id: null,
      error: "",
      contract_uuid: null,
      contract_condition: null,
      products: null,
      customer: null,
      signature: null,
      isMobile: false,
    };
  }
  componentDidMount() {
    this.setState(
      {
        user_id: this.props.match.params.id,
        isMobile: window.innerWidth <= 500,
      },
      async () => await this.getContract()
    );
  }
  componentDidUpdate() {
    if (
      (this.state.isMobile && window.innerWidth >= 500) ||
      (!this.state.isMobile && window.innerWidth <= 500)
    ) {
      const isMobile = window.innerWidth <= 500;
      if (this.state.isMobile !== isMobile) {
        this.setState({
          isMobile: isMobile,
        });
      }
    }
  }

  async getContract() {
    try {
      const res = await axios.get(
        `https://backoffice.nadu.xyz/api/get-contract-token/${this.state.user_id}`
      );
      if (res.data.ok) {
        const { contract_uuid, contract_condition, user_data } = res.data.data;
        const {
          products,
          customer,
          signature,
          signature_date,
          is_company,
          author,
          bic,
        } = user_data;
        this.setState({
          contract_uuid,
          contract_condition,
          products: products,
          customer: { ...customer, bic: bic },
          signature,
          signature_date,
          is_company,
          author,
          loading: false,
        });
      } else {
        this.setState({
          error: res.data.error,
          loading: false,
        });
      }
    } catch (error) {
      this.setState({
        error:
          "Hubo un error al cargar el contrato. Intenta nuevamente más tarde.",
        loading: false,
      });
    }
  }
  render() {
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="print-container" ref={(el) => (this.componentRef = el)}>
          <Watermark height={25} width={100} image={naduLogo}>
            <Card
              style={{
                margin: 0,
              }}
            >
              <CardBody
                className="text-center"
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="text-center" style={{ maxWidth: 1600 }}>
                  {this.state.loading ? (
                    <i className="now-ui-icons arrows-1_refresh-69 spin" />
                  ) : this.state.error ? (
                    <p>{this.state.error}</p>
                  ) : (
                    <div
                      id="printArea"
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Typography.Title
                        level={this.state.isMobile ? 5 : 3}
                        style={{ padding: "24px 0px", margin: "50px 0px" }}
                      >
                        Contrato de prestación de servicios
                      </Typography.Title>
                      {this.state.is_company ? (
                        <BusinessData userData={this.state} />
                      ) : (
                        <UserData userData={this.state} />
                      )}
                      <BillingData userData={this.state} />
                      <ServicesData userData={this.state} />
                      <ContactData userData={this.state} />
                      <ContractConditions
                        isMobile={this.state.isMobile}
                        contractCondition={this.state.contract_condition}
                      />
                      <ServicesData userData={this.state} />
                      {this.state.is_company ? (
                        <BusinessSignature userData={this.state} />
                      ) : (
                        <UserSignature userData={this.state} />
                      )}
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </Watermark>
        </div>
        <ReactToPrint
          trigger={() => {
            return (
              <FloatButton
                type="primary"
                icon={<PrinterOutlined />}
                style={{ bottom: 10, right: 20, width: 50, height: 50 }}
                href="#"
              />
            );
          }}
          content={() => this.componentRef}
        />
      </div>
    );
  }
}

export default ViewContract;



// WEBPACK FOOTER //
// ./src/views/Contract/ViewContract.jsx